export const TOKEN_KEY = "maxClient";
export const PROFILE_USERTYPE = "client";
